document.addEventListener('DOMContentLoaded', () => {
   const fieldsets = document.querySelectorAll('.product-form__input.pl-0.flex.flex-wrap.pb-5.quick-view\\:pb-2.eurus');
   const button = document.getElementById('button_subscription_link');
   const loaderContainer = document.getElementById('loader_container');

   const getVariantValueFromUrl = () => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get("variant");
   };

   const updateButtonLink = (variantValue) => {
      const filteredLink = variant_link_id.map(item => item.split("|")).find(parts => parts[1] === variantValue);
      if (filteredLink) {
         button.href = filteredLink[0];
      } else {
         button.removeAttribute("href");
      }
   };

   if (fieldsets.length && button && loaderContainer) {
      fieldsets.forEach((fieldset) => {
         fieldset.addEventListener('click', () => {
            button.style.visibility = "hidden";
            loaderContainer.style.display = "block";

            setTimeout(() => {
               const variantValue = getVariantValueFromUrl();
               if (variantValue && variant_link_id.length) {
                  updateButtonLink(variantValue);
               }
               loaderContainer.style.display = "none";
               button.style.visibility = "visible";
            }, 1200);
         });
      });
   }
});
